import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { routing } from './pages.routing';
import { NgaModule } from '../theme/nga.module';
import { AppTranslationModule } from 'app/translation/app.translation.module';

//MODULES
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule } from '@angular/forms';

//SERVICES
import { AuthService } from 'app/services/auth';

//COMPONENTS
import { Pages } from './pages.component';
import { BuscarPessoaModalComponent } from './modals/buscar-pessoa-modal';

@NgModule({
  imports: [
    CommonModule, 
    AppTranslationModule, 
    NgaModule, 
    routing,
    Ng2SmartTableModule,
    FormsModule
  ],
  declarations: [
    Pages,
    BuscarPessoaModalComponent
  ],
  entryComponents: [
    BuscarPessoaModalComponent
  ],
  providers: [
    AuthService
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/pages/pages.module.ts